

const role_route = {
    1:[//财务 //允许访问的路由
        "app.home.profile.recharge",
        "app.home.profile.orders",
        "app.home.profile.account",
        "app.home.profile.receipt"
    ],
    2:[//不允许访问的路由
       "app.home.profile.manage"
    ]
}
const name_verifiedAllow = {//未实名认证 允许访问的 页面列表 根据角色判断
   1:["app.home.profile.account"]
}

class Jurisdiction {
    
    constructor(){
        // let user = JSON.parse(window.localStorage.getItem("loginUser"))//不能及时获取到最新的值 待优化
        this.isAllow = false
    }


    checkStatus (params) {//route_name,checkType  控制路由
        // console.log(params.role_type) 
        if(params.role_type === 0){
            return "admin"
        }else if(!params.role_type){//不为0且没有值 未登录
            return true
        }

        params.permissions_list = params.role_permissions.split("|")
        switch(params.role_type){
            case 1 :return this.finance(params);break;
            case 2 :return 2;break;//小编拥有所有路由
        }

    }

    finance(params){//角色——财务
        let isTrue = this.checkName_verified(params,name_verifiedAllow[params.role_type])//是否实名认证

        
        switch(params.checkType){//name_verified|实名认证
            case "route":return  role_route[params.role_type].indexOf(params.route_name) > -1&&isTrue;break;
            case "redirect_route":return {path:isTrue?"app.home.profile.orders":"app.home.profile.account",status:role_route[params.role_type].indexOf(params.route_name) > -1&&isTrue};break;
            case "role_permissions" :return params.permissions_list.indexOf(params.permissions_num) > -1&&isTrue;break;
        }

    }


    checkName_verified(params,list){//检测是否实名认证 不同角色可能会在未实名认证时 可以访问的页面也不同
        
        if(params.name_verified == 0){//未实名
            let index = list.indexOf(params.route_name)
           return index > -1
        }else{
            return true // 已认证
        }

    }
    
    checkStatusShow(params){//角色—— 小编   控制显示隐藏

      // params.role_type = 2 //测试用
      if(params.role_type === 2){// 小编
      
         return  false

      }else{
         return true
      }

    }

    reselut(params,trans){// 统一返回权限

      var statess = trans.router.stateService;
      let route = trans._treeChanges.to[trans._treeChanges.to.length-1].state.name;

      let obj = Object.assign(params,{route_name:route,checkType:"redirect_route"})
      let Identity = this.checkStatus(obj)//检查路由权限

      if(Identity.status===false){
         return statess.target(Identity.path)
      }else{
         switch(Identity){
            case "admin" :return true;break;
            case 2 :return true;break;
            default:return true;break;
         }
      }

    }








}
export default Jurisdiction


// WEBPACK FOOTER //
// ./src/app/services/Jurisdiction/jurisdiction.js